export enum ReportType {
  ESTATES = 'estates',
  EMPLOYEES = 'employees',
  SUBCONTRACTORS = 'subcontractors',
  REVIEWS = 'reviews',
  INSURANCES = 'insurances',
}
